import fetch, { fetchPeriodically } from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import Store from "logic/local-storage/Store";
import EnterpriseApiRoutes from "common/ApiRoutes";
export async function getInstalledBundles() {
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.index().url));
}
export async function getBundlesStatus() {
  return fetchPeriodically("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.status().url));
}
export async function updateBundle({ bundleId, bundleData }) {
  return fetch("POST", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.one(bundleId).url), bundleData);
}
export async function deleteBundle({ bundleId }) {
  return fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.one(bundleId).url));
}
export async function uploadBundle({ bundleFile, nextPercentage = void 0 }) {
  const formData = new FormData();
  const http = new XMLHttpRequest();
  formData.append("file", bundleFile);
  return new Promise((resolve, reject) => {
    http.upload.onprogress = ({ loaded, total }) => {
      const percent = Math.round(loaded * 100 / total);
      nextPercentage(percent);
    };
    http.onreadystatechange = () => {
      var _a, _b;
      if (http.readyState === 4) {
        if (http.status === 200) {
          resolve(http.responseText);
        } else {
          const errorMessage = (_b = (_a = JSON.parse(http.responseText)) == null ? void 0 : _a.message) != null ? _b : http.statusText;
          reject(new Error(errorMessage));
        }
      }
    };
    http.open("POST", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.upload().url), true);
    http.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    http.setRequestHeader("X-Requested-By", "XMLHttpRequest");
    http.setRequestHeader("Access-Control-Allow-Origin", "*");
    http.send(formData);
  });
}
export async function getLatestBundle() {
  return new Promise((resolve, reject) => {
    fetch("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.hub.latest().url)).then((data) => {
      const skipedVersion = Store.get("skiped-bundle-version");
      resolve({
        ...data,
        is_new_version: data.is_new_version && skipedVersion !== data.version
      });
    }).catch((error) => reject(error));
  });
}
export async function getHubBundles() {
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.hub.index().url));
}
export async function getReleaseNotes(version) {
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.hub.releaseNotes(version).url));
}
export async function installHubBundle({ bundleId }) {
  const http = new XMLHttpRequest();
  return new Promise((resolve, reject) => {
    http.onreadystatechange = () => {
      var _a, _b;
      if (http.readyState === 4) {
        if (http.status === 200) {
          resolve(http.responseText);
        } else {
          const errorMessage = (_b = (_a = JSON.parse(http.responseText)) == null ? void 0 : _a.message) != null ? _b : http.statusText;
          reject(new Error(errorMessage));
        }
      }
    };
    http.open("POST", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.hub.install(bundleId).url), true);
    http.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    http.setRequestHeader("X-Requested-By", "XMLHttpRequest");
    http.setRequestHeader("Access-Control-Allow-Origin", "*");
    http.send();
  });
}
export const getInstallationStatus = async () => fetchPeriodically("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.installStatus().url));
export const checkPreviousBundle = async () => fetch("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.previous.checkPrevious().url));
